/* eslint-disable no-loop-func */
/* eslint-disable react-hooks/exhaustive-deps */
import { useCallback } from 'react';
import { TFunction } from 'i18next';
import { Box } from '@mantine/core';

import { CreditOptionsResponse, ExpenseType } from 'types';
import { useForm } from '@mantine/form';
import CreditRequestExpensesItem from './item';

interface CreditRequestExpensesProps {
  disabled?: boolean;
  form: any;
  options: CreditOptionsResponse;
  t: TFunction;
}

interface ExpenseObject {
  creditRequestId?: number;
  expenseType?: ExpenseType;
  amount?: number,
}
const tempExpenseObject = {
  creditRequestId: undefined,
  expenseType: undefined,
  amount: undefined,
} as ExpenseObject;

const propertyName = 'expenses';

const CreditRequestExpenses = ({ disabled, form, options, t }: CreditRequestExpensesProps) => {

  const updateCredit = useCallback(async (array: any) => {
    let tempArray: ExpenseObject[] = [];
    Object.keys(array).forEach(key => {
      let item: ExpenseObject = { ...array[key] };
      const isNotEmpty = item.expenseType || item.amount;
      if (isNotEmpty) {
        item.creditRequestId = form.values.id;
        tempArray.push(item);
      }
    });
    form.setFieldValue(propertyName, tempArray);
  }, []);

  const expenseForm = useForm({
    initialValues: form.values[propertyName] && form.values[propertyName].length > 0 ? form.values[propertyName].map((el: ExpenseObject) => ({ ...el })) : [tempExpenseObject],
    onValuesChange(values, _previous) {
      if (values[values.length - 1] !== tempExpenseObject)
      updateCredit(values);
    },
  });

  return (
    <Box>
      {Object.keys(expenseForm.getTransformedValues()).map((el: any, index: number) => (
        <CreditRequestExpensesItem
          disabled={disabled}
          form={form}
          options={options}
          index={index}
          t={t}
          expenseForm={expenseForm}
          tempExpenseObject={tempExpenseObject}
        />
      ))}
    </Box>
  )
}

export default CreditRequestExpenses;